import { CardContent, CardHeader, Card as MaterialCard } from '@mui/material';
import React from 'react';
import { boxShadowCard } from 'utils/consts';

import Table from './Table';
import Graph from './Graph';

function Card({ title, data, type, exportPdf }) {
  return (
    <MaterialCard
      sx={{
        width: '100%',
        borderRadius: 4,
        boxShadow: boxShadowCard,
        p: 4,
      }}
    >
      <CardHeader
        sx={{
          p: 0,
          '& .MuiCardHeader-content': {
            display: 'flex',
            justifyContent: 'space-between',
          },
        }}
        title={title}
        titleTypographyProps={{
          variant: 'h3',
          fontSize: 22,
          overflow: 'hidden',
          textOverflow: 'ellipsis',
          whiteSpace: 'nowrap',
        }}
      />
      <CardContent sx={{ p: 0, pt: '24px' }}>
        {type?.includes('table') ? (
          <Table data={data} exportPdf={exportPdf} />
        ) : (
          <Graph data={[data]} exportPdf={exportPdf} />
        )}
      </CardContent>
    </MaterialCard>
  );
}

export default Card;
